/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  DatePicker, Drawer, notification, Upload,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import Constants, { DEFAULT_CUR_ROUND_OFF, H3_TITLE, toISTDate } from '@Apis/constants';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import Helpers from '@Apis/helpers';
import OfferActions from '@Actions/offerActions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import DepartmentActions from '@Actions/departmentActions';
import ProductForm from '@Components/Common/ProductForm';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CustomDocumentInputs from '@Components/Common/CustomDocumentInputs';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import FormHelpers from '@Helpers/FormHelpers';
import TagActions from '@Actions/tagActions';
import TagSelector from '@Components/Common/Selector/TagSelector';
import H3Image from '../../../../uilib/h3Image';
import PurchaseRequestLines from './PurchaseRequestLines';
import './style.scss';
import AddToCartActions from '../../../../actions/addToCart/addToCartActions';
import ErrorHandle from '../../../Common/ErrorHandle';
import purchaseRequestErrorList from './PurchaseRequestErrors';
import RestrictedAccessMessage from '../../../Common/RestrictedAccess/RestrictedAccessMessage';
import PRZButton from '../../../Common/UI/PRZButton';
import PRZConfirmationPopover from '../../../Common/UI/PRZConfirmationPopover';
import PRZInput from '../../../Common/UI/PRZInput';
import PRZText from '../../../Common/UI/PRZText';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

class CreatePurchaseRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [
        {
          key: uuidv4(), asset1: '', product_sku_name: '', quantity: '', tax_id: null, uom_id: null, lineCustomFields: [],
        },
      ],
      deliveryDate: dayjs(),
      showAddProductModal: false,
      productKey: '',
      prDate: dayjs(),
      isUserReady: false,
      mrNumber: '',
      cfPurchaseRequestLine: [],
      visibleColumns: {
        PRODUCT: {
          label: 'Product',
          visible: true,
          disabled: true,
        },
        QUANTITY: {
          label: 'Quantity',
          visible: true,
          disabled: true,
        },
        AVAILABLE_QTY: {
          label: 'Available Quantity',
          visible: true,
          disabled: true,
        },
        UNIT_PRICE: {
          label: 'Rate',
          visible: true,
          disabled: true,
        },
        TARGET_PRICE: {
          label: 'Target Price',
          visible: true,
          disabled: true,
        },
      },
      updateDocumentReason: '',
    };
  }

  componentDidMount() {
    const {
      getDocCFV2, user,
    } = this.props;
    this.setState({
      sourceDepartment: Helpers.getDepartmentId(user),
      sourceTenantDepartment: Helpers.getTenantDepartmentId(user),
      selectedTenant: user?.tenant_info?.tenant_id,
    });
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'PURCHASE_REQUEST',
    };
    getDocCFV2(payload);
  }

  getPurchaseRequestErrors() {
    const {
      cfPurchaseRequestDoc, data, cfPurchaseRequestLine, targetPriceMandatory, issuerTenantDepartment, selectedIssuerTenant, mrNumber,
    } = this.state;
    const { docLevelError, lineLevelError } = purchaseRequestErrorList({
      cfPurchaseRequestDoc, data, cfPurchaseRequestLine, targetPriceMandatory, issuerTenantDepartment, selectedIssuerTenant, mrNumber,
    });
    return { docLevelError: docLevelError ?? [], lineLevelError: lineLevelError ?? [] };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      // eslint-disable-next-line react/prop-types
      user, location, getPurchaseRequestById, selectedPurchaseRequest, match, mrpToPrData, mrpData,
    } = props;
    const updatePrId = match.params.prId;
    const prIdParams = location?.state?.clonePrData;
    const urlParams = new URLSearchParams(window.location.search);
    const clonePrData = urlParams.get('clonePrData');
    const prId = prIdParams || clonePrData;
    const dataFromCartToPr = location?.state?.dataForPrefillPR;
    const autoPrintDescription = user?.tenant_info?.global_config?.settings?.print_description_automatically;

    if ((prId || updatePrId) && user?.tenant_info?.tenant_id && !state.isUserReady) {
      getPurchaseRequestById((prId || updatePrId), Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), () => { });
      return {
        ...state,
        isUserReady: true,
      };
    }

    // condition for in case pr lines are prefilling from cart
    if (((dataFromCartToPr) && !state.isUserReadySyncCartData && props.cfV2DocPurchaseRequest)) {
      const lineCFs = CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);
      return {
        ...state,
        cfPurchaseRequestDoc: CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_custom_fields, []) || [],
        cfPurchaseRequestLine: lineCFs,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields, state.visibleColumns),
        isUserReadySyncCartData: true,
        data: dataFromCartToPr?.map((item) => ({
          key: uuidv4(),
          tenant_product_id: item?.tenant_product_id,
          asset1: item?.product_info?.assets?.[0]?.url || '',
          product_sku_name: item?.product_info?.product_sku_name,
          product_sku_id: item?.product_info?.product_sku_id,
          quantity: item.quantity,
          price: item.offer_price,
          uom_id: item?.uom_info?.uom_id || item?.uom_id || '',
          uomId: item?.uom_info?.uom_id || item?.uom_id || '',
          uom_list: item?.product_info?.uom_list,
          uqc: item?.product_info?.uqc || '',
          uomGroup: item?.group_id,
          taxId: item?.product_info?.tax_id,
          otherDepartmentStock: item?.department_quantities,
          targetPrice: item?.sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price,
          maxPrice: item?.sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price,
          minPrice: item?.sellerOffers?.sort((a, b) => a.offer_price - b.offer_price)?.[0]?.offer_price,
          avaragePrice: Helpers.getValueTotalInObject(item?.sellerOffers, 'offer_price') / item?.sellerOffers?.length,
          tax: JSON.stringify({
            tax_id: item?.product_info?.tax_id, tax_name: item?.product_info?.tax_name, tax_value: item?.product_info?.tax_value, uqc: item?.product_info?.uqc,
          }),
          uom_info: item?.uom_info,
          product_sku_info: item?.product_info,
          ref_product_code: item?.ref_product_code,
          internal_sku_code: item?.internal_sku_code,
          remark: autoPrintDescription ? item?.product_info?.description?.replace(/<[^>]+>/g, '') : '',
          remarkRequired: autoPrintDescription ? !!item?.product_info?.description?.replace(/<[^>]+>/g, '') : false,
          lineCustomFields: FormHelpers.lineSystemFieldValue(lineCFs, [...(item?.custom_fields ?? []), ...(item?.system_custom_fields ?? [])])?.map((i) => ({
            ...i,
            fieldValue: i?.fieldName === 'Rate' ? Number(0) : (i?.fieldName === 'Quantity' ? Number(item.quantity || 1) : i?.fieldValue),
          })),
        })),
      };
    }

    // condition for in case pr lines are prefilling from mrp
    if (((mrpToPrData) && !state.isUserReadySyncMrpData && props.cfV2DocPurchaseRequest)) {
      const lineCFs = CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);
      const isPRFromMrpInPurchaseUomEnable = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.create_pr_from_mrp_in_purchase_uom;
      return {
        ...state,
        selectedTenant: mrpData?.tenant_id,
        cfPurchaseRequestDoc: CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_custom_fields, []) || [],
        cfPurchaseRequestLine: lineCFs,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields, state.visibleColumns),
        isUserReadySyncMrpData: true,
        data: mrpToPrData?.map((item) => {
          const lineCfData = FormHelpers.lineSystemFieldValue(
            lineCFs,
            [
              ...(item?.custom_fields ?? []),
              ...(item?.system_custom_fields ?? []),
            ],
          )?.map((i) => {
            let fieldValue;

            // Handle 'Rate' field
            if (i?.fieldName === 'Rate') {
              fieldValue = Number(0); // Set to 0 if the field is 'Rate'
            }
            // Handle 'Quantity' field with conditional logic based on `isPRFromMrpInPurchaseUomEnable`
            else if (i?.fieldName === 'Quantity') {
              if (isPRFromMrpInPurchaseUomEnable) {
                fieldValue = Number(
                  (item?.pending_quantity || 0)
                  * (item?.uom_info?.[0]?.ratio || 1)
                  / (item?.product_sku_info?.purchase_uom_info?.ratio || 1),
                );
              } else {
                fieldValue = item?.pending_quantity;
              }
            }
            // Default case for other fields
            else {
              fieldValue = i?.fieldValue;
            }

            // Return the modified object
            return {
              ...i,
              fieldValue,
            };
          });
          return {
            key: uuidv4(),
            tenant_product_id: item?.tenant_product_id,
            asset1: item?.product_sku_info?.assets?.[0]?.url || '',
            product_sku_name: item?.product_sku_info?.product_sku_name,
            product_sku_id: item?.product_sku_info?.product_sku_id,
            quantity: isPRFromMrpInPurchaseUomEnable ? (
              (item?.pending_quantity || 0)
              * (item?.uom_info?.[0]?.ratio || 1)
            )
              / (item?.product_sku_info?.purchase_uom_info?.ratio || 1) : item?.pending_quantity,
            price: item.offer_price,
            uom_id: isPRFromMrpInPurchaseUomEnable ? item?.product_sku_info?.purchase_uom_info?.uom_id : item?.uom_info?.[0]?.uom_id || '',
            uomId: isPRFromMrpInPurchaseUomEnable ? item?.product_sku_info?.purchase_uom_info?.uom_id : item?.uom_info?.[0]?.uom_id || '',
            uom_list: item?.product_uom_list,
            uqc: isPRFromMrpInPurchaseUomEnable ? item?.product_sku_info?.purchase_uom_info?.uqc : item?.product_sku_info?.uqc || '',
            uomGroup: item?.group_id,
            taxId: item?.product_sku_info?.tax_id,
            currentDepStock: Number(item?.available_quantity),
            targetPrice: item?.sku_offers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price,
            maxPrice: item?.sku_offers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price,
            minPrice: item?.sku_offers?.sort((a, b) => a.offer_price - b.offer_price)?.[0]?.offer_price,
            avaragePrice: Helpers.getValueTotalInObject(item?.sku_offers, 'offer_price') / item?.sku_offers?.length,
            tax: JSON.stringify({
              tax_id: item?.tax_info?.tax_id, tax_name: item?.tax_info?.tax_name, tax_value: item?.tax_info?.tax_value, uqc: isPRFromMrpInPurchaseUomEnable ? item?.product_sku_info?.purchase_uom_info?.uqc : item?.uom_info?.[0]?.uqc,
            }),
            uom_info: isPRFromMrpInPurchaseUomEnable ? item?.product_sku_info?.purchase_uom_info : item?.uom_info?.[0],
            product_sku_info: item?.product_sku_info,
            ref_product_code: item?.ref_product_code,
            internal_sku_code: item?.internal_sku_code,
            remark: autoPrintDescription ? item?.product_sku_info?.description?.replace(/<[^>]+>/g, '') : '',
            remarkRequired: autoPrintDescription ? !!item?.product_sku_info?.description?.replace(/<[^>]+>/g, '') : false,
            lineCustomFields: lineCfData,
          };
        }),
      };
    }

    // condition for in case of clone pr from view pr and list pr screen
    if ((selectedPurchaseRequest && props.cfV2DocPurchaseRequest && !state.isUserReadySyncData && prId)) {
      const oldCustomField = selectedPurchaseRequest?.custom_fields || [];
      const oldLineCustomField = selectedPurchaseRequest?.purchase_requistion_lines[0]?.custom_fields || [];
      return {
        ...state,
        isUserReadySyncData: true,
        selectedPurchaseRequest,
        prDate: toISTDate(new Date()),
        fileList: selectedPurchaseRequest?.attachments,
        sourceDepartment: selectedPurchaseRequest?.department_id,
        sourceTenantDepartment: selectedPurchaseRequest?.tenant_department_id,
        issuerDepartment: selectedPurchaseRequest?.issuer_tenant_department_id,
        issuerTenantDepartment: selectedPurchaseRequest?.issuer_tenant_department_id,
        selectedTenant: selectedPurchaseRequest?.tenant_id,
        selectedIssuerTenant: selectedPurchaseRequest?.issuer_tenant_id,
        selectedTags: selectedPurchaseRequest?.tags || [],
        data: selectedPurchaseRequest?.purchase_requistion_lines?.map((item) => ({
          key: uuidv4(),
          tenant_product_id: item?.tenant_product_id,
          pr_line_id: item.pr_line_id,
          asset1: item?.product_sku_info?.assets?.[0]?.url || '',
          product_sku_name: item?.product_sku_name,
          product_sku_id: item?.product_sku_info?.product_sku_id,
          quantity: item.quantity,
          price: item.offer_price,
          uom_id: item?.uom_info?.uom_id || item?.uom_id || '',
          uomId: item?.uom_info?.uom_id || item?.uom_id || '',
          uom_list: item?.product_sku_info?.uom_list,
          uqc: item?.uqc || '',
          uomGroup: item?.group_id,
          taxId: item?.tax_id,
          tax: JSON.stringify({
            tax_id: item?.tax_id, tax_name: item?.tax_name, tax_value: item?.tax_value, uqc: item?.uqc,
          }),
          uom_info: item?.uom_info,
          product_sku_info: item?.product_sku_info,
          ref_product_code: item?.product_sku_info?.ref_product_code,
          internal_sku_code: item?.product_sku_info?.internal_sku_code,
          remark: item?.remarks,
          targetPrice: item?.target_price,
          remarkRequired: !!item?.remark?.replace(/<[^>]+>/g, ''),
          lineCustomFields: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], oldLineCustomField || []),
        })),
        cfPurchaseRequestDoc: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_custom_fields || [], oldCustomField) || [],
        cfPurchaseRequestLine: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], oldLineCustomField) || [],
        visibleColumns: {
          ...CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], oldLineCustomField)), state.visibleColumns),
        },
      };
    }

    // condition for update pr
    if (updatePrId && props.cfV2DocPurchaseRequest && (props.selectedPurchaseRequest && !state.selectedPurchaseRequest) || (props.selectedPurchaseRequest && state.selectedPurchaseRequest && props.selectedPurchaseRequest?.purchase_requisition_id !== state.selectedPurchaseRequest?.purchase_requisition_id)) {
      const oldCustomField = selectedPurchaseRequest?.custom_fields || [];
      const oldLineCustomField = props?.selectedPurchaseRequest?.purchase_requistion_lines[0]?.custom_fields || [];
      return {
        ...state,
        selectedPurchaseRequest: props.selectedPurchaseRequest,
        prDate: toISTDate(props.selectedPurchaseRequest?.pr_date),
        deliveryDate: toISTDate(props.selectedPurchaseRequest?.delivery_date),
        remark: props.selectedPurchaseRequest?.remark,
        fileList: props.selectedPurchaseRequest?.attachments,
        sourceDepartment: props?.selectedPurchaseRequest?.department_id,
        sourceTenantDepartment: props.selectedPurchaseRequest?.tenant_department_id,
        issuerDepartment: selectedPurchaseRequest?.issuer_department_id,
        issuerTenantDepartment: selectedPurchaseRequest?.issuer_tenant_department_id,
        selectedTenant: props.selectedPurchaseRequest?.tenant_id,
        selectedIssuerTenant: selectedPurchaseRequest?.issuer_tenant_id,
        selectedTags: selectedPurchaseRequest?.tags || [],
        data: props.selectedPurchaseRequest?.purchase_requistion_lines?.map((item) => ({
          key: uuidv4(),
          tenant_product_id: item?.tenant_product_id,
          pr_line_id: item.pr_line_id,
          asset1: item?.product_sku_info?.assets?.[0]?.url || '',
          product_sku_name: item?.product_sku_name,
          product_sku_id: item?.product_sku_info?.product_sku_id,
          quantity: item.quantity,
          price: item.offer_price,
          uom_id: item?.uom_info?.uom_id || item?.uom_id || '',
          uomId: item?.uom_info?.uom_id || item?.uom_id || '',
          uom_list: item?.product_sku_info?.uom_list,
          uqc: item?.uqc || '',
          uomGroup: item?.group_id,
          taxId: item?.tax_id,
          tax: JSON.stringify({
            tax_id: item?.tax_id, tax_name: item?.tax_name, tax_value: item?.tax_value, uqc: item?.uqc,
          }),
          uom_info: item?.uom_info,
          product_sku_info: item?.product_sku_info,
          ref_product_code: item?.product_sku_info?.ref_product_code,
          internal_sku_code: item?.product_sku_info?.internal_sku_code,
          remark: item?.remark,
          remarkRequired: !!item?.remark?.replace(/<[^>]+>/g, ''),
          targetPrice: item?.target_price,
          lineCustomFields: CustomFieldHelpers.mergeCustomFields(props?.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], item?.custom_fields || []),
          productCategoryInfo: item?.product_sku_info?.product_category_info,
        })),
        cfPurchaseRequestDoc: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_custom_fields || [], oldCustomField) || [],
        cfPurchaseRequestLine: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], oldLineCustomField) || [],
        visibleColumns: {
          ...CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields || [], oldLineCustomField)), state.visibleColumns),
        },
        mrNumber: props.selectedPurchaseRequest?.pr_number || '',
      };
    }

    // condition for empty custom field in case of create pr
    if (props.cfV2DocPurchaseRequest && !state.isUserReadyOn && !(updatePrId || prId || dataFromCartToPr || mrpToPrData)) {
      const lineCFs = CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);
      return {
        ...state,
        cfPurchaseRequestDoc: CustomFieldHelpers.getCfStructure(props.cfV2DocPurchaseRequest?.data?.document_custom_fields, []) || [],
        cfPurchaseRequestLine: lineCFs,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields, state.visibleColumns),
        data: state.data.map((item) => ({ ...item, lineCustomFields: lineCFs })),
        isUserReadyOn: true,
      };
    }

    // condition for custom field in case of update pr and clone pr
    if (props.selectedPurchaseRequest?.custom_fields && props.cfV2DocPurchaseRequest && !state.isUserReadyForUpdate && (updatePrId || prId)) {
      const oldCustomField = props.selectedPurchaseRequest?.custom_fields || [];
      const oldLineCustomField = props?.selectedPurchaseRequest?.purchase_requistion_lines[0]?.custom_fields;
      return {
        ...state,
        cfPurchaseRequestDoc: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_custom_fields, oldCustomField),
        cfPurchaseRequestLine: CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields, oldLineCustomField),
        visibleColumns: {
          ...CustomFieldHelpers.updateVisibleColumns(CustomFieldHelpers.postCfStructure(CustomFieldHelpers.mergeCustomFields(props.cfV2DocPurchaseRequest?.data?.document_line_custom_fields, oldLineCustomField)), state.visibleColumns),
        },
        isUserReadyForUpdate: true,
      };
    }

    if (props.user?.tenant_info?.org_id) {
      return {
        ...state,
        targetPriceMandatory: props.user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.purchase_request_target_price_required,
      };
    }
    return state;
  }

  componentWillUnmount() {
    const {
      getPurchaseRequestByIdSuccess,
    } = this.props;
    getPurchaseRequestByIdSuccess(null);
  }

  handleDelete = (key) => {
    const { data, cfPurchaseRequestLine } = this.state;
    if (data.length === 1) {
      this.setState({
        data: [{
          key: uuidv4(), asset1: '', product_name: '', quantity: '', price: '', lot: 0, tax: 0, lineCustomFields: cfPurchaseRequestLine,
        }],
      });
    } else {
      const copyData = data.filter((item) => item.key !== key);
      this.setState({ data: copyData });
    }
  }

  handleProductChange = (tenantSku, key, otherDepStocksData, isMultiMode, callback) => {
    const { data, cfPurchaseRequestLine, selectedTenant } = this.state;
    const { getTenantSkuOffer, user } = this.props;
    const autoPrintDescription = user?.tenant_info?.global_config?.settings?.print_description_automatically;
    if (isMultiMode && Array.isArray(tenantSku)) {
      const tenantProductIds = tenantSku?.map((item) => item?.tenant_product_id)?.join(',');
      getTenantSkuOffer('',
        '',
        (sellerOffers) => {
          const copyData = [];
          let tenantProductSellerOffer;
          for (let i = 0; i < tenantSku?.length; i++) {
            const tenantProductId = tenantSku[i]?.tenant_product_id;
            tenantProductSellerOffer = sellerOffers[tenantProductId]?.[0];
            const otherDepStocksDataItem = otherDepStocksData?.find((item) => item?.product_sku_id === tenantSku[i]?.product_sku_id);
            const newDataRow = this.createData({
              tenantSku: tenantSku[i],
              dataItem: {
                key: uuidv4(),
                lineCustomFields: cfPurchaseRequestLine,
              },
              sellerOffer: tenantProductSellerOffer,
              sellerOffers: sellerOffers[tenantProductId],
              otherDepStocksData: otherDepStocksDataItem,
              selectedTenant,
              autoPrintDescription,
              cfPurchaseRequestLine,
            });
            copyData.push(newDataRow);
          }
          if (callback) callback();

          this.setState((prevState) => ({
            data: [...prevState.data, ...copyData],
          }));
        },
        tenantProductIds);
    } else {
      getTenantSkuOffer(tenantSku?.tenant_product_id, '', (sellerOffer, sellerOffers) => {
        const copyData = JSON.parse(JSON.stringify(data));
        for (let i = 0; i < copyData.length; i++) {
          if (copyData[i].key === key) {
            copyData[i] = this.createData({
              tenantSku,
              dataItem: copyData[i],
              sellerOffer,
              sellerOffers,
              otherDepStocksData,
              selectedTenant,
              autoPrintDescription,
              cfPurchaseRequestLine,
            });
          }
        }
        this.setState({ data: copyData });
      });
    }
  }

  handleMultiProductChange = (selectedProductData, key, otherDepStocksData, callback) => {
    this.handleProductChange(selectedProductData, key, otherDepStocksData, true, callback);
  }

  createData = ({
    tenantSku, dataItem, sellerOffer, sellerOffers, otherDepStocksData, selectedTenant, autoPrintDescription, cfPurchaseRequestLine,
  }) => {
    const dataFromSelectedTenant = otherDepStocksData?.tenant_products?.filter((allTenantId) => allTenantId?.tenant_id === selectedTenant);

    const copyDataItem = JSON.parse(JSON.stringify(dataItem));
    copyDataItem.tenant_product_id = tenantSku?.tenant_product_id;
    copyDataItem.otherDepartmentStock = tenantSku?.department_quantities;
    copyDataItem.product_sku_id = tenantSku?.product_info?.product_sku_id;
    copyDataItem.product_sku_name = `${tenantSku?.product_info.product_sku_name}`;
    copyDataItem.internal_sku_code = tenantSku?.product_info?.internal_sku_code;
    copyDataItem.ref_product_code = tenantSku?.product_info?.ref_product_code;
    copyDataItem.asset1 = tenantSku?.product_info?.assets?.[0]?.url || '';
    copyDataItem.purchase_uom_info = tenantSku?.purchase_uom_info || '';
    copyDataItem.sku = tenantSku?.product_info?.product_sku_id || '';
    copyDataItem.tax = JSON.stringify({ tax_id: tenantSku?.product_info?.tax_id, tax_name: tenantSku?.product_info?.tax_name, tax_value: tenantSku?.product_info?.tax_value });
    copyDataItem.tax_id = tenantSku?.product_info?.tax_id || 0;
    copyDataItem.uom_id = tenantSku?.purchase_uom_info?.uom_id || 0;
    copyDataItem.uomId = tenantSku?.purchase_uom_info?.uom_id || 0;
    copyDataItem.productCategoryInfo = tenantSku?.product_category_info || {};
    copyDataItem.uom_info = tenantSku?.purchase_uom_info;
    copyDataItem.uom_list = tenantSku?.uom_list;
    copyDataItem.uomGroup = tenantSku?.group_id;
    copyDataItem.quantity = 1;
    copyDataItem.pos_quantity_against_product = dataFromSelectedTenant?.[0]?.pos_quantity_against_product;
    copyDataItem.targetPrice = sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price;
    copyDataItem.maxPrice = sellerOffers?.sort((a, b) => b.offer_price - a.offer_price)?.[0]?.offer_price;
    copyDataItem.minPrice = sellerOffers?.sort((a, b) => a.offer_price - b.offer_price)?.[0]?.offer_price;
    copyDataItem.avaragePrice = Helpers.getValueTotalInObject(sellerOffers, 'offer_price') / sellerOffers?.length;
    copyDataItem.remark = autoPrintDescription ? (otherDepStocksData?.description || '')?.replace(/<[^>]+>/g, '') || otherDepStocksData?.product_info?.description : '';
    copyDataItem.remarkRequired = !!otherDepStocksData?.description?.replace(/<[^>]+>/g, '');
    copyDataItem.lineCustomFields = FormHelpers.lineSystemFieldValue(cfPurchaseRequestLine, [...(tenantSku?.custom_fields ?? []), ...(otherDepStocksData?.system_custom_fields ?? [])])?.map((i) => ({
      ...i,
      fieldValue: i?.fieldName === 'Rate' ? Number(sellerOffer?.offer_price || 0) : (i?.fieldName === 'Quantity' ? Number(sellerOffer?.moq || 1) : i?.fieldValue),
    }));
    return copyDataItem;
  }

  handleProductChangeValue = (value, key) => {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i].key === key) {
        const copyDataItem = copyData[i];
        copyDataItem.product_sku_name = value;
        copyData[i] = copyDataItem;
      }
    }
    this.setState({ data: copyData });
  }

  addNewRow() {
    const { data, cfPurchaseRequestLine } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    copyData.push({
      key: uuidv4(),
      asset1: '',
      product_sku_name: '',
      quantity: '',
      tax_id: null,
      uom_id: null,
      lineCustomFields: cfPurchaseRequestLine,
    });
    this.setState({ data: copyData });
  }

  customLineInputChange(fieldValue, key) {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i]?.key === key) {
        copyData[i].lineCustomFields = fieldValue;
        const qtyCf = fieldValue?.find((j) => j?.fieldName === 'Quantity');
        copyData[i].quantity = qtyCf?.fieldValue > 0 ? parseFloat(Number(qtyCf?.fieldValue).toFixed(DEFAULT_CUR_ROUND_OFF)) : '';
      }
    }
    this.setState({ data: copyData });
  }

  isDataValid() {
    const { data, deliveryDate, targetPriceMandatory, issuerTenantDepartment, selectedIssuerTenant } = this.state;
    let isDataValid = true;
    for (let i = 0; i < data.length; i++) {
      if (!data?.[i]?.quantity || Number(data[i].quantity) <= 0 || !data[i].product_sku_name || !CustomFieldHelpers.isCfValid(data[i]?.lineCustomFields) || !data[i].uom_id || (targetPriceMandatory ? !data[i].targetPrice : false)) {
        isDataValid = false;
      }
    }
    if (!deliveryDate) isDataValid = false;

    if ((issuerTenantDepartment && !selectedIssuerTenant) || (!issuerTenantDepartment && selectedIssuerTenant)) isDataValid = false;

    return isDataValid;
  }

  createPurchaseRequest(withApproval) {
    const {
      createPurchaseRequest, history, MONEY, match, location, selectedPurchaseRequest, updatePurchaseRequest, getPurchaseRequestByIdSuccess, createTag, removeFromCartV2, user, getCartV2, mrpId,
    } = this.props;
    const {
      deliveryDate, prDate, data, remark, fileList, cfPurchaseRequestDoc, targetPriceMandatory, sourceTenantDepartment, selectedTenant, selectedIssuerTenant, selectedTags, updateDocumentReason, issuerTenantDepartment, docSeqId, mrNumber, initialMrNumber,
    } = this.state;
    const updatePrId = match.params.prId;
    const prIdParams = location?.state?.clonePrData;
    const urlParams = new URLSearchParams(window.location.search);
    const clonePrData = urlParams.get('clonePrData');
    const prId = prIdParams || clonePrData;
    const purchaseRequestLines = [];
    const { docLevelError, lineLevelError } = this.getPurchaseRequestErrors();
    // Function to strip HTML tags and get text content
    function stripHtmlTags(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    }
    this.setState({ formSubmitted: true, data: JSON.parse(JSON.stringify(data)) });
    if (docLevelError?.length === 0 && lineLevelError?.length === 0) {
      if (!updatePrId) {
        if (this.isDataValid() && deliveryDate && prDate && CustomFieldHelpers.isCfValid(cfPurchaseRequestDoc)) {
          for (let i = 0; i < data.length; i++) {
            const originalRemark = data?.[i].remark || '';
            const textContent = stripHtmlTags(originalRemark).trim();
            const remarkText = textContent ? originalRemark.trim() : '';

            const maxPriceText = (data?.[i].maxPrice && targetPriceMandatory) ? `Max Price: ${MONEY(data?.[i].maxPrice)}, \n` : '';
            const minPriceText = (data?.[i].minPrice && targetPriceMandatory) ? `Min Price: ${MONEY(data?.[i].minPrice)}, \n` : '';
            const averagePriceText = (data?.[i].avaragePrice && targetPriceMandatory) ? `Avg Price: ${MONEY(data?.[i].avaragePrice)}, \n` : '';

            const finalRemark = `${remarkText} ${maxPriceText}${minPriceText}${averagePriceText}`.trim();

            const prLine = {
              tenant_product_id: data?.[i].tenant_product_id,
              product_sku_name: data?.[i].product_sku_name,
              uom_id: data?.[i]?.uom_info?.uom_id,
              uom_info: data?.[i]?.uom_info,
              quantity: Number(data?.[i]?.quantity),
              target_price: data?.[i].targetPrice || null,
              product_sku_id: data?.[i].product_sku_id,
              custom_fields: CustomFieldHelpers.postCfStructure(data[i]?.lineCustomFields),
              remark: finalRemark || '',
            };

            purchaseRequestLines.push(prLine);
          }
          const payload = {
            tenant_id: selectedTenant,
            issuer_tenant_id: selectedIssuerTenant,
            purchase_requisition_lines: purchaseRequestLines,
            remark,
            mrp_id: mrpId,
            pr_date: dayjs(prDate).format('YYYY/MM/DD'),
            delivery_date: dayjs(deliveryDate).format('YYYY/MM/DD'),
            status: withApproval ? 'ISSUED' : 'DRAFT',
            attachments: fileList?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })) || [],
            tenant_department_id: sourceTenantDepartment,
            issuer_tenant_department_id: issuerTenantDepartment || null,
            custom_fields: CustomFieldHelpers.postCfStructure(cfPurchaseRequestDoc),
            seq_id: docSeqId || null,
            pr_number: initialMrNumber?.toLowerCase()?.trim() === mrNumber?.toLowerCase()?.trim() ? null : mrNumber,
          };
          const allProductSkuIds = data?.map((item) => item.product_sku_id);
          createPurchaseRequest([payload], (createdPr) => {
            if (location?.state?.dataForPrefillPR) {
              removeFromCartV2({ product_sku_ids: allProductSkuIds, tenant_id: user?.tenant_info?.tenant_id }, () => {
                getCartV2({ tenantId: user?.tenant_info?.tenant_id });
              });
            }
            if (selectedTags?.length) {
              const tagPayload = {
                entity_name: 'PURCHASE_REQUISITION',
                entity_id: createdPr?.purchase_requisitions?.[0]?.purchase_requisition_id,
                action: 'ADD',
                tag: selectedTags.join(','),
              };
              createTag(tagPayload, () => {
                this.setState({ currentAction: false });
                history.push(`/purchase/purchase-request/view/${createdPr?.purchase_requisitions?.[0]?.purchase_requisition_id}`);
              });
            } else {
              this.setState({ currentAction: false });
              history.push(`/purchase/purchase-request/view/${createdPr?.purchase_requisitions?.[0]?.purchase_requisition_id}`);
            }
          });
        } else {
          notification.open(({
            placement: 'top',
            message: 'Please enter values for all mandatory inputs',
            duration: 4,
            type: 'error',
          }));
        }
      } else if (updatePrId) {
        if (this.isDataValid() && deliveryDate && prDate && CustomFieldHelpers.isCfValid(cfPurchaseRequestDoc)) {
          for (let i = 0; i < data.length; i++) {
            const originalRemark = data?.[i].remark || '';
            const textContent = stripHtmlTags(originalRemark).trim();
            const remarkText = textContent ? originalRemark.trim() : '';
            const prLine = {
              pr_line_id: data?.[i].pr_line_id,
              tenant_product_id: data?.[i].tenant_product_id,
              product_sku_name: data?.[i].product_sku_name,
              product_sku_id: data?.[i].product_sku_id,
              tax_id: data?.[i]?.tax ? JSON.parse(data?.[i]?.tax)?.tax_id : null,
              uom_id: data?.[i]?.uom_id || null,
              uom_info: data?.[i]?.uom_info,
              quantity: Number(data?.[i]?.quantity),
              target_price: Number(data?.[i].targetPrice) || null,
              remark: remarkText,
              purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
              custom_fields: CustomFieldHelpers.postCfStructure(data[i]?.lineCustomFields),
            };
            purchaseRequestLines.push(prLine);
          }
          const payload = {
            tenant_id: selectedPurchaseRequest?.tenant_info?.tenant_id,
            purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
            issuer_tenant_id: selectedIssuerTenant || null,
            purchase_requisition_lines: purchaseRequestLines,
            tenant_department_id: sourceTenantDepartment,
            issuer_tenant_department_id: issuerTenantDepartment || null,
            remark,
            pr_date: toISTDate(prDate).format('YYYY/MM/DD'),
            delivery_date: toISTDate(deliveryDate).format('YYYY/MM/DD'),
            attachments: fileList?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })) || [],
            status: withApproval ? 'ISSUED' : 'DRAFT',
            custom_fields: CustomFieldHelpers.postCfStructure(cfPurchaseRequestDoc),
            update_document_reason: updateDocumentReason,
            pr_number: initialMrNumber?.toLowerCase()?.trim() === mrNumber?.toLowerCase()?.trim() ? null : mrNumber,
          };
          updatePurchaseRequest(payload, (createdPr) => {
            if (selectedTags?.length) {
              const tagPayload = {
                entity_name: 'PURCHASE_REQUISITION',
                entity_id: selectedPurchaseRequest?.purchase_requisition_id,
                action: 'REPLACE',
                tag: selectedTags.join(','),
              };
              createTag(tagPayload, () => {
                this.setState({ actionType: '' });
                getPurchaseRequestByIdSuccess(null);
                history.push(`/purchase/purchase-request/view/${createdPr?.purchase_requisition_id}`);
              });
            } else {
              this.setState({ actionType: '' });
              getPurchaseRequestByIdSuccess(null);
              history.push(`/purchase/purchase-request/view/${createdPr?.purchase_requisition_id}`);
            }
          });
        } else {
          notification.open(({
            placement: 'top',
            message: 'Please enter values for all mandatory inputs',
            duration: 4,
            type: 'error',
          }));
        }
      }
    }
  }

  customInputChange(fieldValue, cfId) {
    const { cfPurchaseRequestDoc } = this.state;
    const newCustomField = cfPurchaseRequestDoc.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })),

          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfPurchaseRequestDoc: newCustomField,
    });
  }

  addProductInfo(productInfo, key, data) {
    const updatedData = data?.map((item) => {
      if (item.key === key) {
        return {
          ...item,
          tax_id: productInfo.tax_id,
          taxId: productInfo.tax_id,
          tax_info: productInfo?.tax_info,
          taxInfo: productInfo?.tax_info,
          uom_id: productInfo.uom_id,
          uomId: productInfo.uom_id,
          uomGroup: productInfo.uom_group,
          uom_info: productInfo.uom_info,
          uomInfo: productInfo.uom_info,
          uom_list: productInfo.uom_list,
          product_sku_name: productInfo.product_sku_name,
          product_info: productInfo, // Update the desired property with the new value
        };
      }
      return item;
    });
    this.setState({ data: updatedData });
  }

  // getDataSource = (data) => {
  //   const copyData = JSON.parse(JSON.stringify(data));
  //   return [...copyData.filter((item) => item?.product_sku_id), ...copyData.filter((item) => !item?.product_sku_id)];
  // }

  getDataSource = (data) => {
    const copyData = structuredClone(data);
    const sortedData = Helpers.sortByParameter({
      data: copyData,
    });

    return [
      ...sortedData.filter((item) => item?.product_sku_id),
      ...sortedData.filter((item) => !item?.product_sku_id),
    ];
  };

  render() {
    const {
      createPurchaseRequestLoading, getPurchaseRequestByIdLoading, user, getDepartments, match, selectedPurchaseRequest, history, updatePurchaseRequestLoading, location, mrpToPrData, priceMasking, mrpId,
    } = this.props;
    const {
      remark, formSubmitted, deliveryDate, data, fileList, cfPurchaseRequestLine, visibleColumns, selectedTags,
      currentAction, cfPurchaseRequestDoc, targetPriceMandatory, sourceDepartment, selectedTenant, showAddProductModal, productKey, sourceTenantDepartment, updateDocumentReason,
      issuerDepartment, issuerTenantDepartment, selectedIssuerTenant, docSeqId, mrNumber, initialMrNumber,
    } = this.state;
    const enableDepartmentSelection = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.allow_pr_creation_from_other_departments;
    let copyDocLevelError;
    let copyLineLevelError;
    if (formSubmitted) {
      const { docLevelError, lineLevelError } = this.getPurchaseRequestErrors();
      copyDocLevelError = docLevelError;
      copyLineLevelError = lineLevelError;
    }

    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

    const prIdParams = location?.state?.clonePrData;
    const urlParams = new URLSearchParams(window.location.search);
    const clonePrData = urlParams.get('clonePrData');
    const prId = prIdParams || clonePrData;

    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{H3_TITLE}</title>
        </Helmet>
        <Drawer
          open={showAddProductModal}
          width="720px"
          mask
          onClose={() => this.setState({ showAddProductModal: false })}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header">
              <H3Text text="Add New Product" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showAddProductModal: false })} />
            </div>
          </div>
          <ProductForm
            productKey={productKey}
            addProductInfo={(productInfo, key) => {
              this.setState({ showAddProductModal: false });
              this.addProductInfo(productInfo, key, data); // productInfo, key, data
            }}
          />
        </Drawer>
        {getPurchaseRequestByIdLoading ? (
          <div className="update-po__loading__wrapper">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <div key={item} className="update-po__loading__wrapper-row">
                <div className="update-po__loading__wrapper-row__label loadingBlock" />
                <div className="update-po__loading__wrapper-row__value loadingBlock" />
              </div>
            ))}
            <div className="update-po__loading__wrapper-table loadingBlock" />
            <div className="update-po__loading__wrapper-details loadingBlock" />

          </div>
        )
          : (
            <Fragment>
              <div
                className="form__wrapper"
                style={{ paddingTop: mrpToPrData ? '0px' : '90px' }}
              >
                {(formSubmitted && (copyDocLevelError?.length > 0 || copyLineLevelError?.length > 0)) && (
                  <ErrorHandle message="Mandatory fields required" docLevelErrors={copyDocLevelError} lineLevelErrors={copyLineLevelError} />
                )}
                <div className="ant-row">
                  <div className="ant-col-md-24">
                    <div className="form__section">
                      <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                        <H3Text text="PART A" className="form__section-title" />
                        <div className="form__section-line" />
                        <div style={{
                          display: 'flex', justifyContent: 'end', alignItems: 'center', marginLeft: '10px',
                        }}
                        >
                          <CustomDocumentInputs
                            customFields={cfPurchaseRequestDoc}
                            updateCustomFields={(cf) => this.setState({ cfPurchaseRequestDoc: cf })}
                          />
                        </div>
                      </div>
                      <div className="form__section-inputs mg-bottom-20">
                        <div className="ant-row">
                          <DocumentNumberSeqInput
                            valueFromProps={mrNumber}
                            updateCase={match?.params?.prId}
                            setInitialDocSeqNumber={(value) => this.setState({ initialMrNumber: value })}
                            entityName="MATERIAL_REQUEST"
                            docSeqId={docSeqId}
                            tenantId={selectedTenant}
                            onChangeFromProps={(event, newValue, seqId) => {
                              this.setState({
                                mrNumber: newValue ? (newValue || '') : (event?.target?.value || ''),
                                docSeqId: seqId,
                              })
                            }}
                            docTitle="Material Request#"
                            formSubmitted={formSubmitted}
                          />
                          <div className="ant-col-md-6">
                            <div className="form__input-row">
                              <H3Text
                                required
                                text={(selectedPurchaseRequest?.tenant_info?.tenant_name && match.params.prId) ? 'Requestor Location' : 'Select Requestor Location'}
                                className="form__input-row__label"
                              />
                              <div className="form__input-row__input">
                                <TenantSelector
                                  hideTitle
                                  selectedTenant={selectedTenant}
                                  showSearch={false}
                                  onChange={(value) => {
                                    this.setState({
                                      selectedTenant: value,
                                      sourceDepartment: user?.user_tenants?.find((item) => item?.tenant_id === value)?.tenant_department_info?.department_id,
                                      sourceTenantDepartment: user?.user_tenants?.find((item) => item?.tenant_id === value)?.tenant_department_info?.tenant_department_id,
                                    });
                                  }}
                                  placeholder="Select Business Unit"
                                  labelClassName="form__input-row__label"
                                  inputClassName="orgFormInput input"
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE)}
                                  disabled={match.params.prId}
                                />
                              </div>
                            </div>
                          </div>
                          {(selectedPurchaseRequest?.tenant_info?.tenant_name && match.params.prId) && (
                            <div className="ant-col-md-6">
                              <div className="form__input-row">
                                <H3Text
                                  text="Requestor"
                                  className="form__input-row__label"
                                />
                                <div className="form__input-row__input">
                                  <H3Text
                                    text={`${selectedPurchaseRequest?.created_by_info?.first_name} on ${dayjs(selectedPurchaseRequest?.created_at).format('DD/MM/YYYY')}`}
                                    style={{ padding: '7px' }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="ant-col-md-6">
                            <div
                              className="form__input-row"
                            >
                              <H3Text
                                required
                                text="Requestor Department"
                                className="form__input-row__label"
                              />
                              <div className="form__input-row__input">
                                <SelectDepartment
                                  hideTitle
                                  selectedDepartment={sourceDepartment}
                                  onChange={(value) => this.setState({
                                    sourceDepartment: value?.department_id,
                                    sourceTenantDepartment: value?.tenant_department_id,
                                  })}
                                  tenantId={selectedTenant}
                                  disabled={createPurchaseRequestLoading || !enableDepartmentSelection}
                                  labelClassName="form__input-row__label"
                                  inputClassName="orgFormInput input"
                                  emptyNotAllowed
                                  excludedDepartments={selectedIssuerTenant === selectedTenant ? [issuerDepartment] : []}
                                />
                                {formSubmitted && !sourceDepartment && (
                                  <div className="input-error">
                                    *Please select a requestor department
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="ant-col-md-6">
                            <div className="form__input-row">
                              <H3Text
                                text={(selectedPurchaseRequest?.tenant_info?.tenant_name && match.params.prId) ? 'Issuer Location' : 'Select Issuer Location'}
                                className="form__input-row__label"
                              />
                              <div className="form__input-row__input">
                                <TenantSelector
                                  hideTitle
                                  selectedTenant={selectedIssuerTenant}
                                  showSearch={false}
                                  onChange={(value) => {
                                    this.setState({
                                      selectedIssuerTenant: value,
                                      issuerDepartment: null,
                                      issuerTenantDepartment: null,
                                    });
                                  }}
                                  placeholder="Select Business Unit"
                                  labelClassName="form__input-row__label"
                                  inputClassName="orgFormInput input"
                                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE)}
                                  allowClear
                                  onClear={() => this.setState({
                                    selectedIssuerTenant: null,
                                    issuerDepartment: null,
                                    issuerTenantDepartment: null,
                                  })}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ant-col-md-6">
                            <div
                              className="form__input-row"
                            >
                              <H3Text
                                required={!!selectedIssuerTenant}
                                text="Issuer Department"
                                className="form__input-row__label"
                              />
                              <div className="form__input-row__input">
                                <SelectDepartment
                                  hideTitle
                                  selectedDepartment={issuerDepartment}
                                  onChange={(value) => this.setState({
                                    issuerDepartment: value?.department_id,
                                    issuerTenantDepartment: value?.tenant_department_id,
                                  })}
                                  tenantId={selectedIssuerTenant}
                                  disabled={createPurchaseRequestLoading || !enableDepartmentSelection || !selectedIssuerTenant}
                                  labelClassName="form__input-row__label"
                                  inputClassName="orgFormInput input"
                                  emptyNotAllowed
                                  allowClear
                                  onClear={() => this.setState({
                                    issuerDepartment: null,
                                    issuerTenantDepartment: null,
                                  })}
                                  excludedDepartments={selectedIssuerTenant === selectedTenant ? [sourceDepartment] : []}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ant-col-md-6">
                            <div className="form__input-row orgInputContainer">
                              <H3Text
                                text="Delivery Date"
                                className="form__input-row__label"
                              />
                              <div className="form__input-row__input">
                                <DatePicker
                                  value={deliveryDate}
                                  onChange={(value) => {
                                    this.setState({ deliveryDate: value });
                                  }}
                                  style={{
                                    borderColor: formSubmitted && !deliveryDate ? 'red' : 'rgba(68, 130, 218, 0.2)',
                                    border: '1px solid rgba(68, 130, 218, 0.2)',
                                    borderRadius: '2px',
                                    height: '28px',
                                    padding: '1px 3px',
                                    width: '100%',
                                    background: 'white',
                                  }}
                                  format="DD/MM/YYYY"
                                />
                                {formSubmitted && !deliveryDate && (
                                  <div className="input-error">
                                    *Please enter delivery date
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="ant-col-md-6">
                            <div className="form__input-row ">
                              <div className="form__input-row__label">
                                Labels
                              </div>
                              <TagSelector
                                hideTitle
                                entityType="PURCHASE_REQUISITION"
                                selectedTags={selectedTags}
                                isMultiple
                                showSearch
                                onChange={(value) => {
                                  this.setState({ selectedTags: value });
                                }}
                                placeholder="Select Tags"
                                isForm
                                containerWrapper="form__input-row__input"
                                disabled={createPurchaseRequestLoading}
                                maxTagCount="responsive"
                              />
                            </div>
                          </div>
                          <CustomFieldV3
                            customFields={cfPurchaseRequestDoc}
                            formSubmitted={formSubmitted}
                            customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                            wrapperClassName="ant-col-md-6"
                            containerClassName="form__input-row"
                            labelClassName="form__input-row__label"
                            inputClassName="form__input-row__input"
                            errorClassName="form__input-row__input-error"
                            disableCase={createPurchaseRequestLoading}
                            hideTitle
                            isCarryForward={mrpToPrData}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__section ">
                      <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                        <H3Text text="PART B" className="form__section-title " />
                        <div className="form__section-line" />
                      </div>
                      <div className="ant-row">
                        <div className="form__input-row">
                          <H3Text
                            text="Internal Remarks"
                            className="form__input-row__label"
                          />
                          <div className="form__input-row__input">
                            <textarea
                              rows="5"
                              cols="50"
                              onChange={(event) => {
                                this.setState({ remark: event.target.value });
                              }}
                              value={remark}
                              style={{
                                resize: 'none',
                                backgroundColor: 'rgb(239, 239, 239)',
                                border: 'none',
                                borderRadius: '4px',
                                marginRight: '15px',
                                height: '103px',
                                padding: '4px 8px',
                              }}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-12">
                          <div
                            className="form__data-attachment"
                          >
                            <label className="form__input-row__label">Attachment(s)</label>
                            <Upload
                              action={Constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              // disabled={getSOByIdLoading}
                              multiple
                              onChange={(fileListData) => {
                                this.setState({
                                  fileList: fileListData?.fileList?.map((item) => ({
                                    ...item,
                                    url: item?.response?.response?.location,
                                  })),
                                });
                              }}
                            >
                              {fileList?.length >= 20 ? null : uploadButton}
                            </Upload>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form__lines-wrapper">
                  <PurchaseRequestLines
                    handleDelete={this.handleDelete}
                    handleProductChange={this.handleProductChange}
                    handleProductChangeValue={this.handleProductChangeValue}
                    data={this.getDataSource(data)}
                    updateData={(updatedData) => this.setState({ data: updatedData })}
                    formSubmitted={formSubmitted}
                    targetPriceMandatory={targetPriceMandatory}
                    selectedTenant={selectedTenant}
                    showAddProductModal={(productData) => {
                      this.setState({ productKey: productData.key });
                      this.setState({ showAddProductModal: true });
                    }}
                    sourceDepartmentId={sourceTenantDepartment}
                    cfPurchaseRequestLine={cfPurchaseRequestLine}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={(val) => this.setState({ visibleColumns: val })}
                    customLineInputChange={(fieldValue, key) => this.customLineInputChange(fieldValue, key)}
                    isUpdateCase={!match.params.prId}
                    isCarryForward={mrpToPrData}
                    mrpId={mrpId}
                    selectedPurchaseRequest={selectedPurchaseRequest}
                    prId={prId}
                    handleMultiProductChange={this.handleMultiProductChange}
                  />
                </div>

                <div className="form__data-wrapper">
                  <div className="ant-row">
                    <div className="ant-col-md-24">
                      <div
                        className={`new-row-button ${data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id)) ? 'new-row-button__disabled' : ''}`}
                        onClick={() => {
                          if (!data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id))) this.addNewRow();
                        }}
                      >
                        <span className="new-row-button__icon">
                          <PlusCircleFilled />
                        </span>
                        <div>New Item</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </Fragment>
          )}
        <div className="form__footer">
          {/* <H3Button
            text="Save as Draft"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            customClass="form__footer-draft"
            onClick={() => {
              this.setState({ currentAction: 'SAVE_AS_DRAFT' });
              if (!createPurchaseRequestLoading) {
                this.createPurchaseRequest(false);
              }
            }}
            isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AS_DRAFT'}
            disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
          />
          <H3Button
            text="Save and Issue"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            customClass="form__footer-submit"
            onClick={() => {
              this.setState({ currentAction: 'SAVE_AND_ISSUE' });
              if (!createPurchaseRequestLoading) {
                this.createPurchaseRequest(true);
              }
            }}
            isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AND_ISSUE'}
            disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
          /> */}
          {(!!match?.params?.prId) ? (
            <Fragment>
              <PRZConfirmationPopover
                title="Are you sure you want to update?"
                content={(
                  <Fragment>
                    <PRZText text="Reason" required />
                    <PRZInput
                      placeholder="Enter update reason"
                      value={updateDocumentReason}
                      onChange={(e) => this.setState({ updateDocumentReason: e.target.value })}
                    />
                  </Fragment>
                )}
                onConfirm={() => {
                  this.setState({ currentAction: 'SAVE_AS_DRAFT' });
                  if (!createPurchaseRequestLoading) {
                    this.createPurchaseRequest(false);
                  }
                }}
                confirmButtonText="Confirm"
                cancelButtonText="Back"
                confirmDisabled={!updateDocumentReason}
              >
                <PRZButton
                  type="default"
                  wrapperStyle={{ marginRight: '10px' }}
                  buttonStyle={{
                    width: '130px',
                    height: '40px',
                    border: '1px solid #2d7df7',
                    color: '#2d7df7',
                  }}
                  isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AS_DRAFT'}
                  disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
                >
                  Save as Draft
                </PRZButton>
              </PRZConfirmationPopover>
              <PRZConfirmationPopover
                title="Are you sure you want to update?"
                content={(
                  <Fragment>
                    <PRZText text="Reason" required />
                    <PRZInput
                      placeholder="Enter update reason"
                      value={updateDocumentReason}
                      onChange={(e) => this.setState({ updateDocumentReason: e.target.value })}
                    />
                  </Fragment>
                )}
                onConfirm={() => {
                  this.setState({ currentAction: 'SAVE_AND_ISSUE' });
                  if (!createPurchaseRequestLoading) {
                    this.createPurchaseRequest(true);
                  }
                }}
                confirmButtonText="Confirm"
                cancelButtonText="Back"
                confirmDisabled={!updateDocumentReason}
              >
                <PRZButton
                  isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AND_ISSUE'}
                  disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
                  buttonStyle={{ width: '130px', height: '40px' }}
                >
                  Save and Issue
                </PRZButton>
              </PRZConfirmationPopover>
            </Fragment>
          ) : (
            <Fragment>
              <PRZButton
                type="default"
                onClick={() => {
                  this.setState({ currentAction: 'SAVE_AS_DRAFT' });
                  if (!createPurchaseRequestLoading) {
                    this.createPurchaseRequest(false);
                  }
                }}
                isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AS_DRAFT'}
                disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
                wrapperStyle={{ marginRight: '10px' }}
                buttonStyle={{
                  width: '130px',
                  height: '40px',
                  border: '1px solid #2d7df7',
                  color: '#2d7df7',
                }}
              >
                Save as Draft
              </PRZButton>
              <PRZButton
                onClick={() => {
                  this.setState({ currentAction: 'SAVE_AND_ISSUE' });
                  if (!createPurchaseRequestLoading) {
                    this.createPurchaseRequest(true);
                  }
                }}
                isLoading={(createPurchaseRequestLoading || updatePurchaseRequestLoading) && currentAction === 'SAVE_AND_ISSUE'}
                disabled={createPurchaseRequestLoading || updatePurchaseRequestLoading}
                buttonStyle={{ width: '130px', height: '40px' }}
              >
                Save and Issue
              </PRZButton>
            </Fragment>
          )}
          {(mrpId || selectedPurchaseRequest?.mrp_id || selectedPurchaseRequest?.mo_id) && !user?.tenant_info?.permission?.editable_material_request_qty_from_mrp && !prId && (
            <RestrictedAccessMessage message="You do not have access to edit Quantity of Products on this page" />
          )}
          {(isDataMaskingPolicyEnable && isHideCostPrice) && <RestrictedAccessMessage message="You don't have access to view & edit target price" />}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, ProductReducers, PurchaseRequestReducers, CFV2Reducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  products: ProductReducers.products,
  createPurchaseRequestLoading: PurchaseRequestReducers.createPurchaseRequestLoading,
  updatePurchaseRequestLoading: PurchaseRequestReducers.updatePurchaseRequestLoading,
  prSequence: PurchaseRequestReducers.prSequence,
  getPurchaseRequestByIdLoading: PurchaseRequestReducers.getPurchaseRequestByIdLoading,
  selectedPurchaseRequest: PurchaseRequestReducers.selectedPurchaseRequest,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  cfV2DocPurchaseRequest: CFV2Reducers.cfV2DocPurchaseRequest,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  updatePurchaseRequest: (payload, callback) => dispatch(PurchaseRequestActions.updatePurchaseRequest(payload, callback)),
  createPurchaseRequest: (payload, callback) => dispatch(PurchaseRequestActions.createPurchaseRequest(payload, callback)),
  getPurchaseRequestById: (prId, tenantId, callback) => dispatch(PurchaseRequestActions.getPurchaseRequestById(prId, tenantId, callback)),
  getPrSequence: (tenantId) => dispatch(PurchaseRequestActions.getPrSequence(tenantId)),
  getPurchaseRequestByIdSuccess: (selectedPr) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(selectedPr)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getTenantSkuOffer: (tenantProductId, tenantSellerId, callback, tenantProductIds) => dispatch(OfferActions.getOfferByTenantSku(tenantProductId, tenantSellerId, callback, tenantProductIds)),
  createTag: (payload, callback) => dispatch(TagActions.createTag(payload, callback)),
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback)),
  removeFromCartV2: (payload, callback) => dispatch(AddToCartActions.removeFromCartV2(payload, callback)),
  getCartV2: (payload, callback) => dispatch(AddToCartActions.getCartV2(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreatePurchaseRequest));
